export default {
    listagem: {
        table: {
            empty: "No se encontraron Trigger",
            nome: "Nombre",
            novo: "Crear Nuevo Trigger",
            regra: "Regla",
            acoes: "Acciónes",
            editar: "Editar",
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nuevo Trigger',
            editar: 'Editar Trigger'
        },
        fields: {
            nome: {
                label: "Nombre",
                description: "Como se llamara el nuevo Trigger?"
            },
            condicao: {
                fields: {
                    firstField: {
                        label: "Campo",
                        description: "Cuál será el campo a validar."
                    },
                    rule: {
                        label: "Condición",
                        description: "Cuál será la condición."
                    },
                    secondField: {
                        label: "Valor",
                        description: "Cuál será el valor a comparar."
                    },
                    thirdField: {
                        label: "Otra Cantidad",
                        description: "Cuál será el otro valor a comparar."
                    }
                },
                DB_fields: {
                    exam_code: "Código de Examen",
                    method_code: "Método de Examen",
                    specimen_code: "Código de Muestra",
                    value_quantity_value: "Valor del resultado",
                    reference_range_text: "Texto de rango de referencia",
                    reference_range_structured: "Rango de referencia estructurado",
                    parent_exam_code: "código de examen para padres"
                },
                rules: {
                    isNull: "Está vacío",
                    isNotNull: "No esta vacio",
                    bigger: "Más grande que",
                    biggerOrEqual: "Mayor qué o igual a",
                    less: "Menos que",
                    lessOrEqual: "Menos que o igual a",
                    equal: "Es igual a",
                    different: "Es otro que",
                    between: "Es entre",
                    notBetween: "No está entre"
                }
            },
            action: {
                label: "Acción",
                description: "¿Cuál será la acción tomada por el sistema?",
                options: {
                    Blocked: "Examen de Bloque",
                    Alert: "Alerta sobre el examen"
                }
            }
        },
        buttons: {
            adicionar_condicao: 'Añadir condición',
            remover_condicao: 'Eliminar condición',
            salvar: 'Guardar Trigger'
        },
        create: {
            success: "¡Trigger creado con éxito!",
            error: "¡Error al crear el Trigger!"
        },
        update: {
            success: "¡Trigger editado con éxito!",
            error: "¡Error al editar Trigger!"
        }
    }
}
